// src/services/exportService.js
// ─────────────────────────────────────────────────────────────────
// Calls GET /export/employees, receives the binary .xlsx, and
// triggers a browser download — no third-party library needed.
// ─────────────────────────────────────────────────────────────────
import api from './api';
import dayjs from 'dayjs';

const exportService = {

  /**
   * Download the full EJT Excel report from the backend.
   * Works by fetching the binary blob, creating an object URL,
   * clicking a hidden <a> tag, then revoking the URL.
   */
  async downloadEmployeeReport() {
    // Use axios responseType: 'blob' to receive binary data
    const response = await api.get('/export/employees', {
      responseType: 'blob',
    });

    // Build filename  e.g.  ErisConnect_EJT_Report_2026-03-17.xlsx
    const today    = dayjs().format('YYYY-MM-DD');
    const filename = `ErisConnect_EJT_Report_${today}.xlsx`;

    // Try to get filename from Content-Disposition header if present
    const contentDisposition = response.headers?.['content-disposition'] ?? '';
    const match = contentDisposition.match(/filename="?([^";\n]+)"?/);
    const finalName = match?.[1] ?? filename;

    // Create object URL and click a hidden anchor to download
    const url  = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href     = url;
    link.download = finalName;
    document.body.appendChild(link);
    link.click();

    // Cleanup
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    }, 200);
  },
};

export default exportService;